const storeSettingTypes = {
  UPDATE_PLATFORM: "UPDATE_PLATFORM",
  UPDATE_SUBDOMAIN: "UPDATE_SUBDOMAIN",
  UPDATE_IS_JOHN_DOE_TEST_MODE: "UPDATE_IS_JOHN_DOE_TEST_MODE",
  UPDATE_BRAND_LOGO: "UPDATE_BRAND_LOGO",
  UPDATE_BASE_URL: "UPDATE_BASE_URL",
  UPDATE_AUTO_ORDER_ID: "UPDATE_AUTO_ORDER_ID",
  UPDATE_AUTO_CID: "UPDATE_AUTO_CID",
  UPDATE_STORE_UNIQUE_ID: "UPDATE_STORE_UNIQUE_ID",
  UPDATE_IS_404: "UPDATE_IS_404",
  UPDATE_THEME_CONFIG_OTHERS: "UPDATE_THEME_CONFIG_OTHERS",
  UPDATE_THEME_CONFIG: "UPDATE_THEME_CONFIG",
  UPDATE_THEME_CONFIG_DA: "UPDATE_THEME_CONFIG_DA",
  UPDATE_THEME_CONFIG_DE: "UPDATE_THEME_CONFIG_DE",
  UPDATE_THEME_CONFIG_EN: "UPDATE_THEME_CONFIG_EN",
  UPDATE_THEME_CONFIG_ES: "UPDATE_THEME_CONFIG_ES",
  UPDATE_THEME_CONFIG_IT: "UPDATE_THEME_CONFIG_IT",
  UPDATE_STORE_NAME: "UPDATE_STORE_NAME",
  UPDATE_STORE_PLAN: "UPDATE_STORE_PLAN",
  UPDATE_TEST_ORDER: "UPDATE_TEST_ORDER",
  IS_CHATGPT_ENABLED: "IS_CHATGPT_ENABLED",
};

const productActionTypes = {
  SET_OTHER_ITEM_PRODUCT_DETAILS_URL: "SET_OTHER_ITEM_PRODUCT_DETAILS_URL",
  SET_CUSTOMER_ID: "SET_CUSTOMER_ID",
  SET_CUSTOMER_NAME: "SET_CUSTOMER_NAME",
  SET_CUSTOMER_EMAIL: "SET_CUSTOMER_EMAIL",
  SET_CUSTOMER_CONTACT: "SET_CUSTOMER_CONTACT",
  SET_ORDER_NUMBER: "SET_ORDER_NUMBER",
  SET_EXCHANGE_ITEM: "SET_EXCHANGE_ITEM",
  SET_ENABLE_INCENTIVE: "SET_ENABLE_INCENTIVE",
  SET_PAYMENT_METHOD: "SET_PAYMENT_METHOD",
  SET_TEST_MODE: "SET_TEST_MODE",
  SET_RETURN_REASON: "SET_RETURN_REASON",
  SET_RETURN_REASON_ID: "SET_RETURN_REASON_ID",
  SET_RETURN_REASON_DESC:"SET_RETURN_REASON_DESC",
  SET_RECENT_ORDER_ID: "SET_RECENT_ORDER_ID",
  SET_COLLECT_PRICE_DIFFERENCE_PERCENT: "SET_COLLECT_PRICE_DIFFERENCE_PERCENT",
  SET_COLLECT_PRICE_DIFFERENCE_PERCENT_VALUE:
    "SET_COLLECT_PRICE_DIFFERENCE_PERCENT_VALUE",
  SET_ORIGINAL_PAYMENT_METHOD_REFUND_AVAILABLE:
    "SET_ORIGINAL_PAYMENT_METHOD_REFUND_AVAILABLE",
  SET_ENABLESTORE_CREDIT_REFUND: "SET_ENABLESTORE_CREDIT_REFUND",
  SET_ASK_ACCOUNT_INFORMATION: "SET_ASK_ACCOUNT_INFORMATION",
  SET_CHARGE_REVERSE_SHIPMENT_EXCHANGE: "SET_CHARGE_REVERSE_SHIPMENT_EXCHANGE",
  SET_REVERSE_SHIPMENT_FEE: "SET_REVERSE_SHIPMENT_FEE",
  SET_COLLECT_PRICE_DIFFERENCE: "SET_COLLECT_PRICE_DIFFERENCE",
  SET_COLLECT_PRICE_DIFFERENCE_AMOUNT: "SET_COLLECT_PRICE_DIFFERENCE_AMOUNT",
  SET_CURRENCY: "SET_CURRENCY",
  SET_SESSION_CURRENCY: "SET_SESSION_CURRENCY",
  SET_NEIGHBORHOOD_COMMERCE: "SET_NEIGHBORHOOD_COMMERCE",
  SET_GET_REFUND: "SET_GET_REFUND",
  SET_IS_SHOW_REFUND: "SET_IS_SHOW_REFUND",
  SET_ORDER_INFO: "SET_ORDER_INFO",
  SET_REASON_DETAILS: "SET_REASON_DETAILS",
  SET_SUB_REASON_DETAILS: "SET_SUB_REASON_DETAILS",
  SET_IS_POLICY_OVERWRITTEN: "SET_IS_POLICY_OVERWRITTEN",
  ALLOW_CUSTOMER_BANK_DETAILS: "ALLOW_CUSTOMER_BANK_DETAILS",
  ALLOW_CUSTOMER_UPI_DETAILS: "ALLOW_CUSTOMER_UPI_DETAILS",
  UPDATE_CUSTOMER_INFO: "UPDATE_CUSTOMER_INFO",
};

const selectedProductActionTypes = {
  SET_VARIANT_ID: "SET_VARIANT_ID",
  SET_PRODUCT_ID: "SET_PRODUCT_ID",
  SET_ITEM_EXCHANGE_ALLOWED: "SET_ITEM_EXCHANGE_ALLOWED",
  SET_RETURN_ALLOWED: "SET_RETURN_ALLOWED",
  SET_SELECTED_PRODUCT_IMAGE: "SET_SELECTED_PRODUCT_IMAGE",
  SET_SHOPIFY_SELECTED_PRODUCT_IMAGE: "SET_SHOPIFY_SELECTED_PRODUCT_IMAGE",
  SET_SELECTED_PRODUCT_PRICE: "SET_SELECTED_PRODUCT_PRICE",
  SET_LINE_ITEM_ID: "SET_LINE_ITEM_ID",
  SET_LINE_ITEM_LOCATION_ID: "SET_LINE_ITEM_LOCATION_ID",
  SET_COUNTRY_CODE: "SET_COUNTRY_CODE",
  SET_SELECTED_ITEM_QUANTITY: "SET_SELECTED_ITEM_QUANTITY",
  SET_STORE_CREDIT_APPLICABLE: "SET_STORE_CREDIT_APPLICABLE",
  SET_ORIGINAL_PAYMENT_APPLICABLE: "SET_ORIGINAL_PAYMENT_APPLICABLE",
  SET_SHOPIFY_REDIRECTION: "SET_SHOPIFY_REDIRECTION",
  UPDATE_CONFIGURED_POLICY_VIOLATED_MESSAGE: "UPDATE_CONFIGURED_POLICY_VIOLATED_MESSAGE",
};

const exchangeSettingsActionTypes = {
  UPDATE_IS_IMAGE_UPLOAD: "UPDATE_IS_IMAGE_UPLOAD",
  UPDATE_IS_MULTIPLE_IMAGES_UPLOAD: "UPDATE_IS_MULTIPLE_IMAGES_UPLOAD",
  UPDATE_IS_SINGLE_IMAGE_UPLOAD: "UPDATE_IS_SINGLE_IMAGE_UPLOAD",
  UPDATE_ALLOW_EXCHANGE: "UPDATE_ALLOW_EXCHANGE",
  UPDATE_ALLOW_RETURN: "UPDATE_ALLOW_RETURN",
  UPDATE_FINAL_EXCHANGE: "UPDATE_FINAL_EXCHANGE",
  UPDATE_IS_ENABLE_REFUND: "UPDATE_IS_ENABLE_REFUND",
  UPDATE_FINAL_INCENTIVE: "UPDATE_FINAL_INCENTIVE",
  UPDATE_NAVIGATE_BACK: "UPDATE_NAVIGATE_BACK",
  UPDATE_NAVIGATE_FORWARD: "UPDATE_NAVIGATE_FORWARD",
  UPDATE_NEW_ITEM_SIZE: "UPDATE_NEW_ITEM_SIZE",
  UPDATE_NEW_ITEM_OTHER_TAG: "UPDATE_NEW_ITEM_OTHER_TAG",
  UPDATE_NEW_ITEM_COLOR: "UPDATE_NEW_ITEM_COLOR",
  UPDATE_NEW_ITEM_NAME: "UPDATE_NEW_ITEM_NAME",
  UPDATE_NEW_ITEM_QTY: "UPDATE_NEW_ITEM_QTY",
  UPDATE_SELECTED_PRODUCT_NAME: "UPDATE_SELECTED_PRODUCT_NAME",
  UPDATE_SELECTED_PRODUCT_NAME_OTHER: "UPDATE_SELECTED_PRODUCT_NAME_OTHER",
  UPDATE_ALLOW_OUT_OF_STOCK: "UPDATE_ALLOW_OUT_OF_STOCK",
  UPDATE_ORDER_EXCHANGE_INFO: "UPDATE_ORDER_EXCHANGE_INFO",
  UPDATE_AVAILABLE_CREDITS_CURRENCY: "UPDATE_AVAILABLE_CREDITS_CURRENCY",
  UPDATE_AVAILABLE_CREDITS: "UPDATE_AVAILABLE_CREDITS",
  UPDATE_BONUS: "UPDATE_BONUS",
  UPDATE_NEW_ITEM_PRICE_CURRENCY: "UPDATE_NEW_ITEM_PRICE_CURRENCY",
  UPDATE_NEW_ITEM_PRICE: "UPDATE_NEW_ITEM_PRICE",
  UPDATE_NEW_ITEM_IMAGE: "UPDATE_NEW_ITEM_IMAGE",
  UPDATE_EXCHANGE_VARIANT_ID: "UPDATE_EXCHANGE_VARIANT_ID",
  UPDATE_EXCHANGE_PRODUCT_ID: "UPDATE_EXCHANGE_PRODUCT_ID",
  UPDATE_SELECTED_COLOR: "UPDATE_SELECTED_COLOR",
  UPDATE_SELECTED_SIZE: "UPDATE_SELECTED_SIZE",
  UPDATE_SELECTED_OTHER: "UPDATE_SELECTED_OTHER",
  UPDATE_NEXT_URL: "UPDATE_NEXT_URL",
  UPDATE_PREV_URL: "UPDATE_PREV_URL",
  UPDATE_OTHER_OPTIONS_COUNT: "UPDATE_OTHER_OPTIONS_COUNT",
  UPDATE_PAGINATED_BY: "UPDATE_PAGINATED_BY",
  UPDATE_VARIANTS_LABELS: "UPDATE_VARIANTS_LABELS",
  UPDATE_SELECTED_ITEM_COLOR: "UPDATE_SELECTED_ITEM_COLOR",
  UPDATE_SELECTED_ITEM_OTHER_TAG: "UPDATE_SELECTED_ITEM_OTHER_TAG",
  UPDATE_SELECTED_ITEM_SIZE: "UPDATE_SELECTED_ITEM_SIZE",
  UPDATE_SELECTED_OTHER_VARIATION_OBJECT:
    "UPDATE_SELECTED_OTHER_VARIATION_OBJECT",
  UPDATE_IMAGE_LIST: "UPDATE_IMAGE_LIST",
  UPDATE_ITEM_TO_BE_RETURNED: "UPDATE_ITEM_TO_BE_RETURNED",
  UPDATE_EXCHANGE_SESSION_PK: "UPDATE_EXCHANGE_SESSION_PK",
  UPDATE_NEW_ITEM_VARIANTS_SHOPIFY: "UPDATE_NEW_ITEM_VARIANTS_SHOPIFY",
  UPDATE_IS_ALLOW_ALL_PRODUCTS: "UPDATE_IS_ALLOW_ALL_PRODUCTS",
  UPDATE_NEW_ITEM_VARIATIONS: "UPDATE_NEW_ITEM_VARIATIONS",
  UPDATE_IS_EXCHANGE_OTHER: "UPDATE_IS_EXCHANGE_OTHER",
};

const paymentSettingTypes = {
  UPDATE_PAYMENT_REQUIRED: "UPDATE_PAYMENT_REQUIRED",
  UPDATE_PAYMENT_LINK: "UPDATE_PAYMENT_LINK",
  UPDATE_PAYMENT_ID: "UPDATE_PAYMENT_ID",
  UPDATE_COUPON_CODE: "UPDATE_COUPON_CODE",
  UPDATE_CUSTOMER_UPI_ID: "UPDATE_CUSTOMER_UPI_ID",
  UPDATE_ACCOUNT_NUMBER: "UPDATE_ACCOUNT_NUMBER",
  UPDATE_IFSC: "UPDATE_IFSC",
  UPDATE_BENEFICIARY_NAME: "UPDATE_BENEFICIARY_NAME",
};

const refundSettingsActionTypes = {
  UPDATE_INCENTIVE: "UPDATE_INCENTIVE",
  UPDATE_THANKYOU_HEADING: "UPDATE_THANKYOU_HEADING",
  UPDATE_THANKYOU_DESCRIPTION: "UPDATE_THANKYOU_DESCRIPTION",
  UPDATE_THANKYOU_CARD_HEADING: "UPDATE_THANKYOU_CARD_HEADING",
  UPDATE_KEEP_THE_ITEM_AMOUNT: "UPDATE_KEEP_THE_ITEM_AMOUNT",
  UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION:
    "UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION",
  UPDATE_REFUND_ORIGINAL_INCENTIVE: "UPDATE_REFUND_ORIGINAL_INCENTIVE",
  UPDATE_REFUND_CREDIT_INCENTIVE: "UPDATE_REFUND_CREDIT_INCENTIVE",
  UPDATE_INCENTIVE_MESSAGE: "UPDATE_INCENTIVE_MESSAGE",
  UPDATE_REFUND_OPTION: "UPDATE_REFUND_OPTION",
  UPDATE_INCENTIVE_STATUS: "UPDATE_INCENTIVE_STATUS",
  UPDATE_REFUND_METHOD: "UPDATE_REFUND_METHOD",
  UPDATE_TOTAL_REFUND: "UPDATE_TOTAL_REFUND",
  UPDATE_REFUND_REVIEW_ROUTE: "UPDATE_REFUND_REVIEW_ROUTE",
  UPDATE_REFUND_AMOUNT_ON_THANK_YOU_CARD:
    "UPDATE_REFUND_AMOUNT_ON_THANK_YOU_CARD",
  UPDATE_ENABLE_INCENTIVE: "UPDATE_ENABLE_INCENTIVE",
  UPDATE_PAYMENT_AMOUNT: "UPDATE_PAYMENT_AMOUNT",
  UPDATE_PAYMENT_GATEWAY_INFO: "UPDATE_PAYMENT_GATEWAY_INFO",
  UPDATE_PAYMENT_LINK: "UPDATE_PAYMENT_LINK",
  UPDATE_PAYMENT_REQUIRED: "UPDATE_PAYMENT_REQUIRED",
  UPDATE_RAZORPAY_PAYMENT_ID: "UPDATE_RAZORPAY_PAYMENT_ID",
  UPDATE_COLLECT_FROM_RAZORPAY: "UPDATE_COLLECT_FROM_RAZORPAY",
  UPDATE_COLLECT_PAYMENT_THROUGH: "UPDATE_COLLECT_PAYMENT_THROUGH",
  UPDATE_RAZORPAY_DETAILS: "UPDATE_RAZORPAY_DETAILS",
};

const themeConfigTypes = {
  UPDATE_ID: "UPDATE_ID",
  UPDATE_CREATED_AT: "UPDATE_CREATED_AT",
  UPDATE_UPDATED_AT: "UPDATE_UPDATED_AT",
  UPDATE_CREATED_BY: "UPDATE_CREATED_BY",
  UPDATE_UPDATED_BY: "UPDATE_UPDATED_BY",
  UPDATE_IS_ACTIVE: "UPDATE_IS_ACTIVE",
  UPDATE_PRIMARY_COLOR: "UPDATE_PRIMARY_COLOR",
  UPDATE_SECONDARY_COLOR: "UPDATE_SECONDARY_COLOR",
  UPDATE_FONT_NAME: "UPDATE_FONT_NAME",
  UPDATE_FONT_URL: "UPDATE_FONT_URL",
  UPDATE_SHOW_COPYRIGHT_SECTION: "UPDATE_SHOW_COPYRIGHT_SECTION",
  UPDATE_COPYRIGHT_SECTION_TEXT: "UPDATE_COPYRIGHT_SECTION_TEXT",
  UPDATE_RETURN_POLICY_URL: "UPDATE_RETURN_POLICY_URL",
  UPDATE_RESPONSE_MSG: "UPDATE_RESPONSE_MSG",
  UPDATE_LANDING_PAGE_TEXT: "UPDATE_LANDING_PAGE_TEXT",
  UPDATE_CONTINUE_BUTTON_LABEL: "UPDATE_CONTINUE_BUTTON_LABEL",
  UPDATE_BACK_BUTTON_LABEL: "UPDATE_BACK_BUTTON_LABEL",
  UPDATE_PAY_NOW_BUTTON_LABEL: "UPDATE_PAY_NOW_BUTTON_LABEL",
  UPDATE_SUBMIT_BUTTON_LABEL: "UPDATE_SUBMIT_BUTTON_LABEL",
  UPDATE_LANDING_PAGE_LEFT_TITLE: "UPDATE_LANDING_PAGE_LEFT_TITLE",
  UPDATE_LANDING_PAGE_LEFT_CONTENT: "UPDATE_LANDING_PAGE_LEFT_CONTENT",
  UPDATE_LANDING_PAGE_CARD_TITLE: "UPDATE_LANDING_PAGE_CARD_TITLE",
  UPDATE_LANDING_PAGE_CARD_BUTTON_LABEL:
    "UPDATE_LANDING_PAGE_CARD_BUTTON_LABEL",
  UPDATE_LANDING_PAGE_ORDER_NO_INPUT_LABEL:
    "UPDATE_LANDING_PAGE_ORDER_NO_INPUT_LABEL",
  UPDATE_LANDING_PAGE_ORDER_NO_INPUT_HOVER:
    "UPDATE_LANDING_PAGE_ORDER_NO_INPUT_HOVER",
  UPDATE_LANDING_PAGE_EMAIL_ID_INPUT_LABEL:
    "UPDATE_LANDING_PAGE_EMAIL_ID_INPUT_LABEL",
  UPDATE_ITEM_SELECTION_PAGE_TITLE: "UPDATE_ITEM_SELECTION_PAGE_TITLE",
  UPDATE_REASON_SELECTION_PAGE_TITLE: "UPDATE_REASON_SELECTION_PAGE_TITLE",
  UPDATE_RETURN_EXCHANGE_PAGE_TITLE: "UPDATE_RETURN_EXCHANGE_PAGE_TITLE",
  UPDATE_RETURN_EXCHANGE_PAGE_EXCHANGE_CARD_LABEL:
    "UPDATE_RETURN_EXCHANGE_PAGE_EXCHANGE_CARD_LABEL",
  UPDATE_RETURN_EXCHANGE_PAGE_RETURN_CARD_LABEL:
    "UPDATE_RETURN_EXCHANGE_PAGE_RETURN_CARD_LABEL",
  UPDATE_RETURN_OPTION_PAGE_TITLE: "UPDATE_RETURN_OPTION_PAGE_TITLE",
  UPDATE_RETURN_OPTION_PAGE_INCENTIVE_CARD_TITLE:
    "UPDATE_RETURN_OPTION_PAGE_INCENTIVE_CARD_TITLE",
  UPDATE_RETURN_OPTION_PAGE_INCENTIVE_CARD_CONTENT:
    "UPDATE_RETURN_OPTION_PAGE_INCENTIVE_CARD_CONTENT",
  UPDATE_RETURN_OPTION_PAGE_REFUND_CARD_TITLE:
    "UPDATE_RETURN_OPTION_PAGE_REFUND_CARD_TITLE",
  UPDATE_RETURN_OPTION_PAGE_REFUND_CARD_CONTENT:
    "UPDATE_RETURN_OPTION_PAGE_REFUND_CARD_CONTENT",
  UPDATE_REFUND_METHOD_PAGE_TITLE: "REFUND_METHOD_PAGE_TITLE",
  UPDATE_REFUND_METHOD_PAGE_ORIGINAL_PAYMENT_CARD_TITLE:
    "UPDATE_REFUND_METHOD_PAGE_ORIGINAL_PAYMENT_CARD_TITLE",
  UPDATE_REFUND_METHOD_PAGE_ORIGINAL_PAYMENT_CARD_CONTENT:
    "UPDATE_REFUND_METHOD_PAGE_ORIGINAL_PAYMENT_CARD_CONTENT",
  UPDATE_REFUND_METHOD_PAGE_STORE_CREDIT_CARD_TITLE:
    "UPDATE_REFUND_METHOD_PAGE_STORE_CREDIT_CARD_TITLE",
  UPDATE_REFUND_METHOD_PAGE_STORE_CREDIT_CARD_CONTENT:
    "UPDATE_REFUND_METHOD_PAGE_STORE_CREDIT_CARD_CONTENT",
  UPDATE_RETURN_SUBMISSION_STORE_CREDIT_LEFT_TITLE:
    "UPDATE_RETURN_SUBMISSION_STORE_CREDIT_LEFT_TITLE",
  UPDATE_RETURN_SUBMISSION_STORE_CREDIT_LEFT_CONTENT:
    "UPDATE_RETURN_SUBMISSION_STORE_CREDIT_LEFT_CONTENT",
  UPDATE_RETURN_SUBMISSION_STORE_CREDIT_LEFT_BUTTON_LABEL:
    "UPDATE_RETURN_SUBMISSION_STORE_CREDIT_LEFT_BUTTON_LABEL",
  UPDATE_RETURN_SUBMISSION_STORE_CREDIT_RIGHT_CARD_TITLE:
    "UPDATE_RETURN_SUBMISSION_STORE_CREDIT_RIGHT_CARD_TITLE",
  UPDATE_RETURN_SUBMISSION_STORE_CREDIT_RIGHT_CARD_SUBTITLE:
    "UPDATE_RETURN_SUBMISSION_STORE_CREDIT_RIGHT_CARD_SUBTITLE",
  UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_LEFT_TITLE:
    "UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_LEFT_TITLE",
  UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_LEFT_CONTENT:
    "UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_LEFT_CONTENT",
  UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_LEFT_BUTTON_LABEL:
    "UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_LEFT_BUTTON_LABEL",
  UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_RIGHT_CARD_TITLE:
    "UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_RIGHT_CARD_TITLE",
  UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_RIGHT_CARD_SUBTITLE:
    "UPDATE_RETURN_SUBMISSION_ORIGINAL_PAYMENT_RIGHT_CARD_SUBTITLE",
  UPDATE_INCENTIVE_ACCEPT_LEFT_TITLE: "UPDATE_INCENTIVE_ACCEPT_LEFT_TITLE",
  UPDATE_INCENTIVE_ACCEPT_LEFT_CONTENT: "UPDATE_INCENTIVE_ACCEPT_LEFT_CONTENT",
  UPDATE_INCENTIVE_ACCEPT_LEFT_BUTTON_LABEL:
    "UPDATE_INCENTIVE_ACCEPT_LEFT_BUTTON_LABEL",
  UPDATE_INCENTIVE_ACCEPT_RIGHT_CARD_TITLE:
    "UPDATE_INCENTIVE_ACCEPT_RIGHT_CARD_TITLE",
  UPDATE_INCENTIVE_ACCEPT_RIGHT_CARD_SUBTITLE:
    "UPDATE_INCENTIVE_ACCEPT_RIGHT_CARD_SUBTITLE",
  UPDATE_EXCHANGE_PRODUCT_DETAIL_LEFT_TITLE:
    "UPDATE_EXCHANGE_PRODUCT_DETAIL_LEFT_TITLE",
  UPDATE_EXCHANGE_PRODUCT_DETAIL_LEFT_SUBTITLE:
    "UPDATE_EXCHANGE_PRODUCT_DETAIL_LEFT_SUBTITLE",
  UPDATE_EXCHANGE_PRODUCT_DETAIL_SEE_ALL_BUTTON_LABEL:
    "UPDATE_EXCHANGE_PRODUCT_DETAIL_SEE_ALL_BUTTON_LABEL",
  UPDATE_EXCHANGE_PRODUCT_DETAIL_RIGHT_CARD_TITLE:
    "UPDATE_EXCHANGE_PRODUCT_DETAIL_RIGHT_CARD_TITLE",
  UPDATE_EXCHANGE_PRODUCT_DETAIL_RIGHT_CARD_SUBTITLE:
    "UPDATE_EXCHANGE_PRODUCT_DETAIL_RIGHT_CARD_SUBTITLE",
  UPDATE_EXCHANGE_REVIEW_PAGE_LEFT_TITLE:
    "UPDATE_EXCHANGE_REVIEW_PAGE_LEFT_TITLE",
  UPDATE_EXCHANGE_REVIEW_PAGE_SUBMIT_BUTTON_LABEL:
    "UPDATE_EXCHANGE_REVIEW_PAGE_SUBMIT_BUTTON_LABEL",
  UPDATE_EXCHANGE_REVIEW_PAGE_PAY_BUTTON_LABEL:
    "UPDATE_EXCHANGE_REVIEW_PAGE_PAY_BUTTON_LABEL",
  UPDATE_EXCHANGE_REVIEW_ITEM_VALUE_LABEL:
    "UPDATE_EXCHANGE_REVIEW_ITEM_VALUE_LABEL",
  UPDATE_EXCHANGE_REVIEW_PICKUP_FEE_LABEL:
    "UPDATE_EXCHANGE_REVIEW_PICKUP_FEE_LABEL",
  UPDATE_EXCHANGE_REVIEW_PRICE_DIFFERENCE_LABEL:
    "UPDATE_EXCHANGE_REVIEW_PRICE_DIFFERENCE_LABEL",
  UPDATE_EXCHANGE_REVIEW_TOTAL_DUE_LABEL:
    "UPDATE_EXCHANGE_REVIEW_TOTAL_DUE_LABEL",
  UPDATE_EXCHANGE_REVIEW_TOTAL_REFUND_LABEL:
    "UPDATE_EXCHANGE_REVIEW_TOTAL_REFUND_LABEL",
  UPDATE_EXCHANGE_PAYMENT_PAGE_LEFT_TITLE:
    "UPDATE_EXCHANGE_PAYMENT_PAGE_LEFT_TITLE",
  UPDATE_EXCHANGE_PAYMENT_PAGE_LEFT_CONTENT:
    "UPDATE_EXCHANGE_PAYMENT_PAGE_LEFT_CONTENT",
  UPDATE_EXCHANGE_PAYMENT_PAGE_PAY_NOW_BUTTON_LABEL:
    "UPDATE_EXCHANGE_PAYMENT_PAGE_PAY_NOW_BUTTON_LABEL",
  UPDATE_EXCHANGE_SUBMISSION_PAGE_LEFT_TITLE:
    "UPDATE_EXCHANGE_SUBMISSION_PAGE_LEFT_TITLE",
  UPDATE_EXCHANGE_SUBMISSION_PAGE_LEFT_CONTENT:
    "UPDATE_EXCHANGE_SUBMISSION_PAGE_LEFT_CONTENT",
  UPDATE_EXCHANGE_SUBMISSION_PAGE_CONTINUE_BUTTON_LABEL:
    "UPDATE_EXCHANGE_SUBMISSION_PAGE_CONTINUE_BUTTON_LABEL",
  UPDATE_IMAGE_UPLOAD_PAGE_TITLE: "UPDATE_IMAGE_UPLOAD_PAGE_TITLE",
  UPDATE_IMAGE_UPLOAD_PAGE_UPLOADING_MESSAGE:
    "UPDATE_IMAGE_UPLOAD_PAGE_UPLOADING_MESSAGE",
  UPDATE_ERRORS_INVALID_ORDER_NUMBER: "UPDATE_ERRORS_INVALID_ORDER_NUMBER",
  UPDATE_ERRORS_INVALID_CUSTOMER_DATA: "UPDATE_ERRORS_INVALID_CUSTOMER_DATA",
  UPDATE_ERRORS_VIOLATED_POLICY: "UPDATE_ERRORS_VIOLATED_POLICY",
  UPDATE_ERRORS_OPTION_NOT_ALLOWED: "UPDATE_ERRORS_OPTION_NOT_ALLOWED",
  UPDATE_ERRORS_PRODUCT_OUT_OF_STOCK: "UPDATE_ERRORS_PRODUCT_OUT_OF_STOCK",
  UPDATE_STORE: "UPDATE_STORE",
};

const otherSettingsActionTypes = {
  UPDATE_RAN: "UPDATE_RAN",
  UPDATE_ACCESS_CODE: "UPDATE_ACCESS_CODE",
  UPDATE_IS_IMG_OPTIONAL: "UPDATE_IS_IMG_OPTIONAL",
  UPDATE_DEFAULT_IMAGE: "UPDATE_DEFAULT_IMAGE",
};

export {
  storeSettingTypes,
  productActionTypes,
  selectedProductActionTypes,
  exchangeSettingsActionTypes,
  paymentSettingTypes,
  refundSettingsActionTypes,
  themeConfigTypes,
  otherSettingsActionTypes,
};
